class BodyPart {
    getColorSets(colorSets) {
        let results = [];

        if (_.isArray(colorSets) ) {
            _.each(colorSets, set => {
                if (!set) return;

                let sets = []
                let colorSet = _.clone(set);
                let colors  = JSON.parse(colorSet.colors);
                let availableColors = _.size(QX7Rule.colors) > 0 ? QX7Rule.colors : ub.data.colors

                _.each(colors, code => {
                    let colorObject = _.find(availableColors, {color_code: code});

                    if (_.isUndefined(colorObject)) return;

                    sets.push(colorObject);
                })

                colorSet.colors = sets;
                
                results.push(colorSet);
            });
        }

        return results;
    }

    getColorGroups(partColorGroups) {
        if (!_.isEmpty(partColorGroups)) {
            const results = JSON.parse(JSON.parse(partColorGroups));
            return results
        }
    }

    getFabricGroups(partFabricGroups) {
        if (!_.isEmpty(partFabricGroups)) {
            return JSON.parse(JSON.parse(partFabricGroups));
        }

        return [];
    }

    getColorGroupByRulePartName(rulePartName) {
        const results = [];
        let groupName = "";

        _.each(QX7Rule.materialColorGroups, grp => {
            if (Array.isArray(grp["Body Parts"]) && grp["Body Parts"].includes(rulePartName)) {
              results.push(grp["Body Part Group"]);
            }
        });

        if (results.length > 0) {
           groupName = _.first(results)
        }

        (results.length > 1) && console.error(`Multiple group names are detected for part ${rulePartName}. return first value.`);

        return groupName;
    }

    getGroupMatOptionCodes(groupName) {
        const codes = [];

        _.each(ub.current_material.settings[ub.config.type], setting => {
            if (_.isObject(setting) && !_.isEmpty(setting)) {
                if (groupName && setting.rule_part_group === groupName) {
                    codes.push(setting.code);
                }
                if (ub.config.blockPattern === 'Stock Polo') {
                    ub.current_material.settings['upper']['Body'].rule_part_group = 'Body';
                    ub.current_material.settings['upper']['Mascot Guide 1'].rule_part_group = 'Body';
                    ub.current_material.settings['upper']['Mascot Guide 2'].rule_part_group = 'Body';
                    ub.current_material.settings['upper']['Mascot Guide 3'].rule_part_group = 'Body';
                    ub.current_material.settings['upper']['Mascot Guide 4'].rule_part_group = 'Body';
                }
            }
        })

        return codes;
    }

    changeGroupColor(groupName, color, callback) {
        const matOptCodes = QX7Rule.BodyPart.getGroupMatOptionCodes(groupName);
        const source = "from color picker"; // ??
        let isChanged = false;

        console.assert(!_.isEmpty(matOptCodes), `No rule part names available or rule_part_names are not sync for ${groupName}. Please check rule.`);

        if (!_.isEmpty(matOptCodes)) {
            isChanged = true;

            _.each(matOptCodes, (code) => {
                ub.funcs.setMaterialOptionSettingsColor(code, color, source);
                ub.funcs.ui.setMatchingColor(code, color, source);
                if (ub.data.afterLoadCalled !== 1) return;
                ub.change_material_option_color16(code, parseInt(color.hex_code, 16));
            });
        }

        callback(isChanged);
    }
}